import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { HeadCell, TableCell, Typography } from '../../../../../../ui-kit';
import { PendingListItemFormValue } from '../../types';

interface ConnectCardsTableHeadCellProps {
    index: number;
    headCell: HeadCell<PendingListItemFormValue[]>;
}

const ConnectCardsTableHeadCell = ({
    index, headCell,
}: ConnectCardsTableHeadCellProps) => {
    const { t } = useTranslation();

    const isSticky = index === 0;
    return (
        <TableCell
            id={headCell.id as string}
            key={headCell.id as string}
            align={headCell.align}
            isTableHead
            isSticky={isSticky}
            padding='none'
        >
            <Box p={1}>
                <Typography uppercase color='textSecondary' variant='caption'>{t(...headCell.label)}</Typography>
            </Box>
        </TableCell>
    );
};

export default ConnectCardsTableHeadCell;
